<template>
  <div class="ng-content-wrap">
    <NgongVegBanner />
    <div class="ng-block-head ng-block-head-lg">
      <div class="ng-block-head-sub d-print-none">
        <router-link class="back-to" to="/">
          <em class="icon ni ni-chevron-left-c mr-1"></em>
          <span>Dashboard</span>
        </router-link>
      </div>
      <div class="ng-block-between-md g-4">
        <div class="ng-block-head-content">
          <h2 class="ng-block-title fw-normal">
            {{ $route.meta.title }}
          </h2>
          <h3 class="ng-block-title fw-normal" v-if="user_id">
            {{ customer?.name }}
          </h3>
          <div v-if="!margins.margins" class="row">
            <!-- Margins -->
            <div>
              <button
                v-if="!downloadLoading"
                class="btn btn-white btn-dim btn-outline-primary"
                @click="fetchMarginsExport()"
              >
                Download Customer Margins Report
              </button>
              <button
                v-else
                class="btn btn-white btn-dim btn-outline-primary"
                disabled
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Fetching Report</span>
                </div>
                Fetching Report
              </button>
            </div>
            <!-- Margins -->

            <!-- Profitability -->
            <div class="ml-1">
              <button
                v-if="!downloadLoading"
                class="btn btn-white btn-dim btn-outline-primary"
                @click="fetchProfitabilityExport()"
              >
                Download Profitability Report
              </button>
              <button
                v-else
                class="btn btn-white btn-dim btn-outline-primary"
                disabled
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Fetching Report</span>
                </div>
                Fetching Report
              </button>
            </div>
            <!-- Profitability -->
          </div>
        </div>
        <div class="ng-block-head-content">
          <ul class="ng-block-tools gx-3 d-print-none">
            <li>
              <a
                href="#pickDates"
                data-toggle="modal"
                class="btn btn-white btn-dim btn-outline-primary mr-2"
              >
                <em class="icon ni ni-calendar"></em>
                <span>
                  <span class="d-none d-sm-inline-block"> Report Dates </span>
                </span>
              </a>
              <!-- Date Selection Modal -->
              <div class="modal fade" tabindex="-1" id="pickDates">
                <div class="modal-dialog" role="document">
                  <div class="modal-content justify-content-center">
                    <button
                      id="hideNewForm"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em class="icon ni ni-cross text-white"></em>
                    </button>

                    <div class="modal-header bg-primary">
                      <h5 class="modal-title text-white">
                        Select Week Start Date
                      </h5>
                    </div>

                    <div class="modal-body row justify-content-center">
                      <div
                        class="col-md-7 justify-content-center text-center mb-1"
                      >
                        <v-date-picker is-range v-model="reportDates" />
                      </div>
                      <div class="col-md-5 text-center">
                        <h5>Starting on</h5>
                        <p>
                          {{ fD(reportDates.start) }}
                        </p>

                        <h5>Ending on</h5>
                        <p>
                          {{ fD(reportDates.end) }}
                        </p>

                        <button
                          class="btn btn-outline-primary float-right"
                          data-dismiss="modal"
                        >
                          <span> Use Selected Dates </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Date Selection Modal -->
            </li>
            <li v-if="customers.length">
              <div class="input-group">
                <div class="input-group-prepend d-none d-sm-flex">
                  <span
                    class="input-group-text bg-primary text-white font-weight-bold"
                  >
                    Customer
                  </span>
                </div>
                <Multiselect
                  :options="customers"
                  v-model="user_id"
                  trackBy="name"
                  label="name"
                  valueProp="id"
                  :searchable="true"
                  placeholder="Start typing..."
                  @change="fetchMargins"
                />
              </div>
            </li>
          </ul>
          <div class="mt-2">
            <h6> Report for {{ fD(reportDates.start, "E, do MMM") }} to {{ fD(reportDates.end, "E, do MMM") }} </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="ng-block">
      <div class="card card-bordered loading" v-if="processing">
        <div class="justify-content-center text-center">
          <div class="spinner-grow text-primary m-3" role="status">
            <span class="sr-only">Processing Data...</span>
          </div>
          <h6 class="mb-4">Processing Data...</h6>
        </div>
      </div>
      <div v-else>
        <div v-if="user_id" class="row">
          <div v-if="margins.margins.length > 0" class="row">
            <div class="col-12 mb-3">
              <button
                v-if="!downloadLoading"
                class="btn btn-white btn-dim btn-outline-primary"
                @click="fetchMarginsExport(user_id)"
              >
                Download Margins Report
              </button>
              <button
                v-else
                class="btn btn-white btn-dim btn-outline-primary"
                disabled
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Fetching Report</span>
                </div>
                Fetching Report
              </button>
            </div>
            <div class="col-6">
              <div class="card card-bordered">
                <div class="card-content">
                  <table class="table">
                    <tbody class="tb-odr-body">
                    <tr class="tb-odr-item">
                      <th>Agent</th>
                      <td class="text-right">
                        <b>
                          {{ customer?.contact?.agent?.name }}
                        </b>
                      </td>
                    </tr>
                    <tr class="tb-odr-item">
                      <th>Freight</th>
                      <td class="text-right">
                        <b>{{ margins.freight_type }}</b>
                      </td>
                    </tr>
                    <tr class="tb-odr-item">
                      <th>Rebate</th>
                      <td class="text-right">
                        <b>{{ customer?.contact?.rebate }}%</b>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="card card-bordered">
                <div class="card-content">
                  <table class="table">
                    <tbody class="tb-odr-body">
                    <tr class="tb-odr-item">
                      <th>Freight Rate</th>
                      <td class="text-right">
                        <b>{{ margins.freight_rate }}</b>
                      </td>
                    </tr>
                    <tr class="tb-odr-item">
                      <th>Gross Freight Rate</th>
                      <td class="text-right">
                        <b>{{ margins.freight_rate_gross }}</b>
                      </td>
                    </tr>
                    <tr class="tb-odr-item">
                      <th>
                        <span v-if="customer?.contact?.currency == 'euro'">
                          €
                        </span>
                        <span
                            v-else-if="customer?.contact?.currency == 'pound'"
                        >
                          £
                        </span>
                        <span
                            v-else-if="customer?.contact?.currency == 'dollar'"
                        >
                          $
                        </span>
                        <span v-else>
                          KSh
                        </span>
                        Freight Rate
                      </th>
                      <td class="text-right">
                        <b>{{ margins.converted_freight_rate_gross }}</b>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="mt-4 col-12">
              <div class="card card-bordered">
                <div class="card-content">
                  <table class="table pmd-table">
                    <thead class="tb-odr-head">
                      <tr>
                        <th colspan="2" class="text-right">
                          Weight (g)
                        </th>
                        <th class="text-right">
                          Pack
                        </th>
                        <th class="text-right">
                          Count
                        </th>
                        <th class="text-right">
                          Per Pack
                        </th>
                        <th class="text-right">
                          Per Box
                        </th>
                        <th class="text-right">
                          Per Kg
                        </th>
                        <th class="text-right">
                          Per Kg (After Rebate)
                        </th>
                        <th class="text-right">
                          £ Kg Price
                        </th>
                        <th class="text-right">
                          £ Cost Price
                        </th>
                        <th class="text-right">
                          Margin
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                          v-for="(margin, key) in margins.margins"
                          :key="key"
                      >
                        <td>
                          <span v-if="margin.assignment?.brand_id">
                            ({{ margin.assignment?.brand.name }})
                          </span>
                          {{ margin.assignment?.name }}
                        </td>
                        <td class="text-right">
                          {{ addCommas(margin.assignment?.weight) }}
                        </td>
                        <td class="text-right">
                          {{ margin.assignment?.primary_packaging?.name }}
                        </td>
                        <td class="text-right">
                          {{ addCommas(margin.assignment?.count) }}
                        </td>
                        <td class="text-right">
                          <span v-if="customer?.contact?.currency == 'euro'">
                            €
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'pound'"
                          >
                            £
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'dollar'"
                          >
                            $
                          </span>
                          <span v-else>
                            KSh
                          </span>
                          {{ addCommas(margin.per_pack) }}
                        </td>
                        <td class="text-right">
                          <span v-if="customer?.contact?.currency == 'euro'">
                            €
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'pound'"
                          >
                            £
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'dollar'"
                          >
                            $
                          </span>
                          <span v-else>
                            KSh
                          </span>
                          {{ addCommas(margin.per_box) }}
                        </td>
                        <td class="text-right">
                          <span v-if="customer?.contact?.currency == 'euro'">
                            €
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'pound'"
                          >
                            £
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'dollar'"
                          >
                            $
                          </span>
                          <span v-else>
                            KSh
                          </span>
                          {{ addCommas(margin.per_kg) }}
                        </td>
                        <td class="text-right">
                          <span v-if="customer?.contact?.currency == 'euro'">
                            €
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'pound'"
                          >
                            £
                          </span>
                          <span
                              v-else-if="customer?.contact?.currency == 'dollar'"
                          >
                            $
                          </span>
                          <span v-else>
                            KSh
                          </span>
                          {{ addCommas(margin.per_kg_after_rebate) }}
                        </td>
                        <td class="text-right">
                          £ {{ addCommas(margin.pound_per_kg) }}
                        </td>
                        <td class="text-right">
                          <span v-if="margin.calculation">
                            <a :href="'/calculations/' + margin.calculation.id" target="_blank" style="text-decoration: underline;"> £ {{ addCommas(margin.cost_price) }} </a>
                          </span>
                          <span v-else>
                            £ {{ addCommas(margin.cost_price) }}
                          </span>
                        </td>
                        <td class="text-right">{{ margin.margin }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-tranx border-0" v-else>
            <tr class="tb-odr-item alert alert-danger border-0">
              <td colspan="9" class="text-center">
                <h4>
                  <em class="icon ni ni-alert-c text-danger mr-2"></em>
                  No products assigned to
                  {{ customer?.name }}...
                </h4>
                <router-link
                    to="/customers/assignments"
                    class="btn btn-outline-primary btn-sm"
                >
                  <span>Assign Products Now</span>
                  <em class="icon ni ni-chevron-right-c"></em>
                </router-link>
              </td>
            </tr>
          </table>
        </div>
        <div class="alert alert-warning text-center" v-else>
          <h5>
            <em class="icon ni ni-alert text-warning"></em>
          </h5>
          Please select a customer first.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AxiosResponse } from "axios";
import NgongVegBanner from "@/components/NgongVegBanner";
import { computed, defineComponent, onMounted, ref } from "vue";
import http from "../../../../../common/services/http";
import { format } from "date-fns";

export default defineComponent({
  name: "Margins",
  components: { NgongVegBanner },
  setup() {
    const processing = ref(false);
    const downloadLoading = ref(false);

    const customers = ref([]);
    const user_id = ref(0);
    const customer = computed((): any => {
      return customers.value?.find((c: any) => c.id == user_id.value);
    });

    const margins = ref({});

    function fetchCustomers() {
      processing.value = true;
      http.get(`/api/users?role=customer&active=1&fetch=all`).then(res => {
        customers.value = res.data;
        processing.value = false;
      });
    }

    function fetchMargins(id: any) {
      processing.value = true;

      http.get(`/api/margins?customer=${id}`).then(res => {
        margins.value = res.data;
        processing.value = false;
      });
    }

    function addCommas(value: number) {
      if (value !== undefined) {
        const value2dp = value.toFixed(2);
        return value2dp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }

    function downloadReport(response: AxiosResponse<any>, reportName?: any) {
      const fileUrl = window.URL.createObjectURL(response.data);
      const fileLink = document.createElement("a");
      const date = format(new Date(), "yyyy-MM-dd");

      fileLink.href = fileUrl;
      fileLink.setAttribute(
        "download",
        reportName + date + ".xlsx",
      );
      document.body.appendChild(fileLink);

      fileLink.click();

      downloadLoading.value = false;
    }

    function fetchMarginsExport(id?: any) {
      downloadLoading.value = true;
      if (id) {
        let name;
        name = customer.value?.name
        http
          .get(
            `/api/margins-by-customer-report?customer=${id}&start=${fD(
              reportDates.value.start, "yyy-MM-dd"
            )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response, customer.value?.name + " Margins Report ")
          })
      } else {
        http
          .get(
            `/api/margins-by-customer-report?start=${fD(
              reportDates.value.start, "yyy-MM-dd"
            )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response, "Customer Margins Report ")
          })
      }
    }

    function fetchProfitabilityExport() {
      downloadLoading.value = true;
      http
        .get(
          `/api/customer-profitability-report?start=${fD(
            reportDates.value.start, "yyy-MM-dd"
          )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
          {
            responseType: "blob"
          }
        ).then(response => {
          downloadReport(
            response,
            "Customer Profitability Report (" + fD(
              reportDates.value.start, "yyy-MM-dd"
            ) + " to " + fD(reportDates.value.end, "yyyy-MM-dd") + ") "
          )
        })
    }

    function friday() {
      const date = new Date();
      const last = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000);

      return date.getDay() < 5
        ? new Date(last.setDate(last.getDate() - (last.getDay() - 1) + 4))
        : new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 4));
    }

    const start = ref(friday());
    const end = computed(
      () => new Date(new Date(start.value).getTime() + 6 * 24 * 60 * 60 * 1000)
    );

    function fD(d: any, f = "PPPP") {
      return format(d, f);
    }

    const reportDates = ref({
      start: friday(),
      end: new Date(new Date(friday()).getTime() + 6 * 24 * 60 * 60 * 1000),
    })

    onMounted(() => {
      fetchCustomers();
    });

    return {
      user_id,
      customer,
      customers,
      fetchMargins,
      margins,
      processing,
      addCommas,
      downloadLoading,
      fetchMarginsExport,
      // start,
      // end,
      fD,
      fetchProfitabilityExport,
      reportDates,
    };
  }
});
</script>

<style scoped></style>
